export enum BurrellesDeletionEnum {
    doesNotMatchInstructions,
    duplicate,
    clipQuality,
    housekeeping,
    lateClip,
    noLongerSearchTerm,
    other
}
